import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SidneyCustomFlowService {

    constructor(private http: HttpClient) { }

    public executeSidneyCustomFlow(serviceCenterId: string, serviceRequestId: string): void {
        const sidneyId = environment.SidneySCID || '';
        
        console.log(`[SidneyCustomFlow] Validating execution. Current SCID: ${serviceCenterId}, Expected SCID: ${sidneyId}`);

        if (!sidneyId || !serviceCenterId || serviceCenterId.toLowerCase() !== sidneyId.toLowerCase()) {
            console.log(`[SidneyCustomFlow] Skipped. Current ServiceCenter is not Sidney.`);
            return;
        }

        console.log(`[SidneyCustomFlow] Sidney SCID matched! Proceeding with custom flow for serviceRequestId: ${serviceRequestId}`);

        // Extract token from localStorage (auth_token or tokenCorrelative)
        const token = localStorage.getItem('auth_token') || localStorage.getItem('tokenCorrelative') || '';
        let reqOptions = {};
        if (token) {
            reqOptions = { headers: new HttpHeaders({ 'Authorization': `Bearer ${token}` }) };
        } else {
            console.warn('[SidneyCustomFlow] Warning: No auth_token found in localStorage. The request might fail due to missing authorization headers.');
        }

        // 1. Fetch SolicitudId
        const filterUrl = `${environment.api}/api/v1/solicitudes/filter`;
        const filterPayload = {
            ServiceCenterId: serviceCenterId,
            serviceRequestId: serviceRequestId
        };

        this.http.post<any>(filterUrl, filterPayload, reqOptions).subscribe({
            next: (res) => {
                console.log('[SidneyCustomFlow] filter response Payload:', res);
                
                // Extracting based on typical .NET/MyServy payload structures, now explicitly including 'list'
                const dataObj = res?.list || res?.data || res?.result?.items || res?.result?.data || res?.result || res?.items || res;
                const solicitud = Array.isArray(dataObj) ? dataObj[0] : dataObj;
                
                console.log('[SidneyCustomFlow] Extracted Solicitud object:', solicitud);

                // Attempt multiple casings for Id
                const solicitudId = solicitud?.id || solicitud?.Id || solicitud?.solicitudId || solicitud?.SolicitudId || solicitud?.serviceRequestId;

                if (solicitudId) {
                    console.log(`[SidneyCustomFlow] Captured SolicitudId: ${solicitudId}. Proceeding to Phase 3 (Update)...`);
                    
                    // 2. Change Status to 5
                    const updateUrl = `${environment.api}/api/v1/solicitudes/change-of-status/${solicitudId}/5`;
                    
                    // Execute GET request as per swagger definition endpoint
                    this.http.get(updateUrl, reqOptions).subscribe({
                        next: () => console.log(`[SidneyCustomFlow] Successfully updated status to 5 via GET for Solicitud: ${solicitudId}`),
                        error: (err) => console.error('[SidneyCustomFlow] Error updating status via GET', err)
                    });
                } else {
                    console.warn('[SidneyCustomFlow] Phase 3 Aborted: Custom flow triggered but no valid SolicitudId found in the response payload. Unable to change status.', res);
                }
            },
            error: (err) => {
                console.error('[SidneyCustomFlow] Error fetching solicitud via POST /filter for custom flow. Ensure authentication tokens have proper rights.', err);
            }
        });
    }
}
